var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4650",
    "data-name": "Raggruppa 4650",
    transform: "translate(-129 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-filter",
    "data-name": "Icon awesome-filter",
    d: "M14.809,0H.729A.729.729,0,0,0,.214,1.243L5.827,6.857V13.11a.728.728,0,0,0,.311.6l2.428,1.7a.729.729,0,0,0,1.146-.6V6.857l5.613-5.613A.729.729,0,0,0,14.809,0Z",
    transform: "translate(133 236)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4649",
    "data-name": "Raggruppa 4649",
    transform: "translate(58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4647",
    "data-name": "Raggruppa 4647",
    transform: "translate(47 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2109",
    "data-name": "Rettangolo 2109",
    width: 24,
    height: 24,
    transform: "translate(24 190)",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.c23988284b19d8b353ec12255d7e766a.svg";
export { ForwardRef as ReactComponent };